var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_vm._v(" Lorem Ipsum"),_c('br'),_c('i',[_vm._v("Lorem Ipsum")]),_c('br'),_c('em',[_vm._v("Lorem Ipsum")])])}]

export { render, staticRenderFns }